import React from 'react';

const Pneuma = () => {
  return (
    <>
      <style>
        {`
          .container {
            background-color: #000;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .pulsing-circle {
            width: 200px;
            height: 200px;
            border-radius: 50%;
            background: linear-gradient(45deg, white, blue, green);
            display: flex;
            justify-content: center;
            align-items: center;
            animation: pulse 2s infinite;
          }
          .symbols {
            font-size: 50px;
            color: white;
          }
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
          }
        `}
      </style>
      <div className="container">
        <div className="pulsing-circle">
          <div className="symbols">⬥ ↻ ◇ 🌬️</div>
        </div>
      </div>
    </>
  );
};

export default Pneuma;